export default "__VITE_ASSET__C3SE$kj9__"